
import { MenuItem, Dialog, DialogContent, IconButton, Typography, Button, Toolbar, AppBar, Stack, Box } from "@mui/material"
import { Close } from '@mui/icons-material';
import { Form, TextInput, useGetIdentity, useGetOne, useNotify, useRecordContext, useRedirect, useTranslate } from "react-admin"
import { CreateInvoiceReminderCommand, InvoiceReadModel, UserReadModel } from "../../GeneratedClients/FreeBillApi"
import { useEffect, useState } from "react"
import { useMutation } from "react-query";
import { apiService } from "../../apiService"
import { defaultTextInvoiceReminder } from "../../emails/actionDialogs/getDefaultText"
import getSubjectForInvoiceReminder from "./getSubjectForInvoiceReminder"

const CreateInvoiceReminderMenuItem = ({handleClose}: {handleClose: () => void}) => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !identityLoading})
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const invoice = useRecordContext<InvoiceReadModel>()
  const [open, setOpen] = useState<boolean>(false)
  const [initialCommand, setInitialCommand] = useState<CreateInvoiceReminderCommand>()
  const { mutate, isLoading } = useMutation((command: CreateInvoiceReminderCommand) => 
    apiService.InvoicesApi.createInvoiceReminder({createInvoiceReminderCommand: command, id: command.id!}),
    {
      onSuccess: (data) => {
        notify(translate("resources.invoices.notifications.invoiceReminderCreated"))
        redirect('list', 'invoiceReminders')
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleCloseDialog = () => {
    handleClose()
    setOpen(false)
  }

  useEffect(() => {
    const initialCommand: CreateInvoiceReminderCommand = {
      id: invoice.id, 
      subject: getSubjectForInvoiceReminder(invoice.reminderStepNumber, invoice.textModel?.heading),
      message: defaultTextInvoiceReminder(user, invoice.reminderStepNumber), 
      userId: invoice.userId
    }
    setInitialCommand(initialCommand)
  }, [])

  

  const handleSubmit = (command: CreateInvoiceReminderCommand) => {
    mutate(command)
  }

  if(!invoice || identityLoading || userLoading) return null

  return (
    <>
      <MenuItem
        onClick={handleOpen}
        key={"sendInvoiceReminder"}
      >
        {translate('resources.invoices.actions.createInvoiceReminder')}
      </MenuItem>
      <Dialog 
        open={open}
        onClose={handleClose}
        fullScreen
      >
        <Form record={initialCommand} onSubmit={handleSubmit}>
          <AppBar sx={{position: 'relative'}}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseDialog}
              >
                <Close />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component={'div'} variant="h6" color={"inherit"}>
                {translate("resources.invoices.dialogs.createInvoiceReminder")}
              </Typography>
              <Button variant="contained" color="success" autoFocus type="submit" disabled={isLoading} >{translate('resources.invoices.actions.createInvoiceReminder')}</Button>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Stack px={6} py={2} spacing={0}>
              <Box>
                <TextInput 
                  sx={{m:0}} 
                  size="small" 
                  fullWidth 
                  source="subject" 
                  label={`Betreff`}
                />
              </Box>
              <Box>
                <TextInput 
                  label={'Nachricht'}
                  size="small" 
                  source="message"
                  sx={{whiteSpace: 'pre-line'}}
                  fullWidth
                  multiline
                  rows={12}
                />
              </Box>
            </Stack>
          </DialogContent>
        </Form>
      </Dialog>
    </>
  )
}

export default CreateInvoiceReminderMenuItem